import * as _ from 'underscore';

import { appStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import {
  DataRoleContentType,
  IContentType,
} from '../models/ContentTypes';

export function ContentUrlForItem(item: {id: string, path?: string}, itemType: IContentType) {

  if (itemType.name === 'workbook') {
    const siteUrls = siteUrlsSelector(appStore.getState());
    return siteUrls ? siteUrls.workbookUrl(item.id) : '';

  } else if (itemType.name === 'datasource') {
    const siteUrls = siteUrlsSelector(appStore.getState());
    return siteUrls ? siteUrls.datasourceUrl(item.id) : '';

  } else if (itemType.name === 'view') {
    // only shows up in ChangeViewTagsAction and the item type is IViewBase there
    const siteUrls = siteUrlsSelector(appStore.getState());
    return siteUrls ? siteUrls.viewUrl(item.path) : '';

  } else if (itemType.name === 'project') {
    const siteUrls = siteUrlsSelector(appStore.getState());
    return siteUrls ? siteUrls.projectUrl(item.id) : '';

  } else if (itemType.name === 'flow') {
    const siteUrls = siteUrlsSelector(appStore.getState());
    return siteUrls ? siteUrls.flowUrl(item.id) : '';

  } else if (itemType.name === 'metric') {
    const siteUrls = siteUrlsSelector(appStore.getState());
    return siteUrls ? siteUrls.metricUrl(item.id) : '';

  } else if (itemType.name === DataRoleContentType.name) {
    const siteUrls = siteUrlsSelector(appStore.getState());
    return siteUrls ? siteUrls.dataRoleUrl(item.id) : '';
  }

  throw new Error('State not known for ' + itemType.name);
}
